import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";
import { DataPuRequest, DataPuResponse } from "./types";

export const getsDataPuNIBKbli = createAsyncThunk(
    "getsDataPuNIBKbli",
    async (data: DataPuRequest, thunkAPI) => {
        const config = {
            method: "get",
            url: "pelaku-usaha/kbli",
            params: data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);


const DataNIBKbliSlice = createSlice({
    name: "DataNIBSlice",
    initialState: {
        dataKbli: {
            GETS_PU: {

            },
        } as DataPuResponse,
        isSuccessKbli: false,
        isFetching: false,
        isError: false,
        isAuth: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearState: (state, action) => {
            state.isFetching = false;
            state.isSuccessKbli = false;
            state.isError = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        // getsDataPuNIBKbli
        builder.addCase(getsDataPuNIBKbli.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccessKbli = true;
            state.dataKbli = payload;
            return state;
        });
        builder.addCase(getsDataPuNIBKbli.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getsDataPuNIBKbli.pending, (state, action) => {
            state.isFetching = true;
        });


    },
});

export const { clearState } = DataNIBKbliSlice.actions;
export default DataNIBKbliSlice.reducer;
